<template>
  <div>
    <div class="hero is-cover is-relative is-fullheight-with-navbar">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title is-1 has-text-white">I'm Andrew Truex.</h1>
          <h2 class="subtitle is-3 has-text-light">
            A Vue.js focused web developer.
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: "home"
  // components: {
  //   HelloWorld
  // }
}
</script>
<style scoped>
.hero-body {
  background-color: #1a2b33;
}
</style>
